import { useTranslation } from "react-i18next";
import wifiBoostIllustration from "@static/img/broadband/wifiBoostIllustration.png";
import { HomeMarketingInformationCards } from "@features/home/common/HomeMarketingInformationCards/HomeMarketingInformationCards";

export const MarketingInformationCardsWifiBoost = () => {
    const { t } = useTranslation("home");

    const wifiCardsInfos = [
        {
            title: t("broadbandMarketing.wifiBoost.cards.widerCoverage.title"),
            description: t("broadbandMarketing.wifiBoost.cards.widerCoverage.description"),
        },
        {
            title: t("broadbandMarketing.wifiBoost.cards.seamlessConnection.title"),
            description: t("broadbandMarketing.wifiBoost.cards.seamlessConnection.description"),
        },
        {
            title: t("broadbandMarketing.wifiBoost.cards.simpleInstall.title"),
            description: t("broadbandMarketing.wifiBoost.cards.simpleInstall.description"),
        },
        {
            title: t("broadbandMarketing.wifiBoost.cards.connectMore.title"),
            description: t("broadbandMarketing.wifiBoost.cards.connectMore.description"),
        },
    ];

    return (
        <HomeMarketingInformationCards
            cardsInfos={wifiCardsInfos}
            imageAlt={t("broadbandMarketing.wifiBoost.imageAlt")}
            imageSrc={wifiBoostIllustration}
            title={t("broadbandMarketing.wifiBoost.title")}
        />
    );
};
